import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {ProductM} from "../model/product.model";
import {Util} from "../util/util";


@Injectable()
export class ProductService {

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(searchStr: string, status: string, seller_id: number, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/product/list?searchStr=${searchStr}&status_stock=${status}&seller_id=${seller_id}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getDetail(id: string) {
    this.reloadToken()
    return this.http.get(`/api/product/detail/${id}`, this.options).map(res => res.json());
  }

  create(item: ProductM) {
    this.reloadToken()
    return this.http.post(`/api/product`, item, this.options).map(res => res.json());
  }

  update(item: ProductM) {
    this.reloadToken()
    return this.http.put(`/api/product/detail/${item.id}`, item, this.options).map(res => res.json());
  }

  updateStatus(id: number, status: string) {
    this.reloadToken()
    return this.http.put(`/api/product/status/${id}/${status}`, this.options).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/product.service.ts